export default "/Frontend/dist/xls-required.3c9a78e3ea00b6688110f5bef97a2dcd.svg";